<template>
  <div class="general">
    <div class="general__image">
      <img :src="imageUrl" alt="Onboarding Introduction" />
    </div>
    <div class="general__header" v-html="title"></div>
    <div class="general__caption" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
      required: false
    },
    subTitle: {
      type: String,
      default: "",
      required: false
    },
    imageName: {
      type: String,
      default: "",
      required: false
    },
    objUserSetting: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    imageUrl(){
      let path = `${process.env.VUE_APP_SCONTENT_URL}/line-liff/onboarding`
      if(this.objUserSetting.theme === 'dark') return `${path}/dark/${this.imageName}`
      else return `${path}/${this.imageName}`

    }
  },
}
</script>

<style lang="scss" scoped>
@import "./styles/_OnboardingGeneral";
</style>